module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/sp-txt-closed@2x-d3eebdb3cdea05f681841696f4ce920d.png";